// extracted by mini-css-extract-plugin
module.exports = {"messageItem":"CancelPopup_messageItem__n7CZm","messageListItem":"CancelPopup_messageListItem__1c8Ri"};